
import { setLStore } from "@js/public/mUtils";
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import { NoScroll, Scroll } from "@js/public/animation";
export default {
name: "Money",
components: {
InlineLoading
},
props: ["scroll"],
data() {
return {
tabShow: 1 
};
},
activated() {
this.eventBus.$emit("changeMenu", 1);
this.$store.commit('tabBarNumber', 1)
},
created() {
this.eventBus.$on("changeTab", val => {
this.changeTab(val);
});
this.$emit("changeMenu", 1);
},
mounted() {},
watch: {},
methods: {

changeTab(tab) {
this.tabShow = tab;
},

clickTab(link, tab) {
this.tabShow = tab;
console.log("tab:" + link);
if (tab == 1) {
this.sa.track('fund_page_button_click', {
first_module: '理财',
second_module: '顶部',
third_module: '顶部',
button_name: '全部',
module_sort: tab
})
} else {
this.sa.track('fund_page_button_click', {
first_module: '理财',
second_module: '顶部',
third_module: '顶部',
button_name: '收藏',
module_sort: tab
})
}
this.$refs.child.initScroll();
this.toPage(link, {});
},
searchShow() {

this.sa.track('fund_page_button_click', {
first_module: '理财',
second_module: '顶部',
third_module: '顶部',
button_name: '搜索',
module_sort: 2
})

this.toPage("/comeIn/money/search", {});
}
}
};



// WEBPACK FOOTER //
// ./src/components/home/money.vue